import type { AccessConfigRepository } from '../domain'
import type { UseCase } from '@/core/shared'

export const addUserToAccessConfig: UseCase<AccessConfigRepository, 'addUserToAccessConfig'> = (repository) => {
  return async (addUserToAccessConfig) => {
    await repository.addUserToAccessConfig(addUserToAccessConfig)
  }
}
